<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-layout row wrap>
      <div v-for="(item, index) in tiles" v-bind:key="index">
        <material-stats-card
          :color="item.color"
          :icon="item.icon"
          :value="$t(item.title)"
          v-if="!item.vif || item.vif.call(this)"
        >
          <template slot="actions">
            <div class="d-flex justify-center flex-wrap">
              <v-btn
                v-for="(button, index) in item.buttons"
                v-bind:key="index"
                text
                color="primary"
                @click="button.action.call(this)"
              >
                {{ $t(button.title) }}
              </v-btn>
            </div>
          </template>
        </material-stats-card>
      </div>
    </v-layout>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { planSetter } from "../mixins/planSetter";
import SettingsService from "@/services/settings.service"
export default {
  data() {
    return {
      broker: null,
      tiles: [
        {
          title: "views.portal.portal_content",
          color: this.$vuetify.theme.themes.light.secondary,
          icon: "palette",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "portalContent",
                  params: { planId: this.selectedPlan.Id },
                });
              },
            },
          ],
          vif: () =>
              this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1
          // vif: () => !SettingsService.settings.UseNewPortalUI
        },
        {
          title: "views.portal.portal_configuration",
          color: this.$vuetify.theme.themes.light.secondary,
          icon: "settings",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "portalPlanSettings",
                  params: { planId: this.selectedPlan.Id },
                });
              },
            },
          ],
          vif: () =>
              this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1
        },
        {
          title: "views.portal.benefit_cards",
          color: this.$vuetify.theme.themes.light.secondary,
          icon: "credit_card",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "benefitCards",
                  params: {
                    planId: this.selectedPlan.Id,
                    edit: true,
                    cms: "new",
                  },
                });
              },
            },
          ],
          vif: () => {
            // console.log(this.selectedPlan);
            return this.selectedPlan.PlanType === "HW" && ( this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1);
          },
        },
        {
          title: "views.portal.drugs_and_provider_index",
          color: this.$vuetify.theme.themes.light.secondary,
          icon: "local_hospital",
          buttons: [
            {
              title: "views.portal.drug_list",
              action: () => {
                this.$router.push({
                  name: "drugs",
                  params: { planId: this.selectedPlan.Id, cms: "new" },
                });
              },
            },
            {
              title: "views.portal.provider_list",
              action: () => {
                this.$router.push({
                  name: "providers",
                  params: { planId: this.selectedPlan.Id, cms: "new" },
                });
              },
            },
          ],
          vif: () => {
            return this.selectedPlan.PlanType === "HW" && ( this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1);
          },
        },
        {
          title: "views.portal.welcome_kit",
          color: this.$vuetify.theme.themes.light.secondary,
          icon: "mail",
          buttons: [
            {
              title: "components.vuematerialdashboard.core.drawer.view_edit",
              action: () => {
                this.$router.push({
                  name: "welcomeKitNew",
                  params: {
                    planId: this.selectedPlan.Id,
                    edit: true,
                    cms: "new",
                  },
                });
              },
            },
          ],
          vif: () =>
              this.role.indexOf("Broker Plan Manager") > -1 ||
                this.role.indexOf("Member Portal Admin") > -1
        },
        {
          title: "views.portal.users_management",
          vif: () => {
            return (this.selectedPlan.PlanType === "NoManaged");
          },
          color: "rgb(0, 124, 181)",
          icon: "group",
          buttons: [
            {
              title: "views.portal.view_&_manage",
              action: () => {
                this.$router.push({
                  name: "usersManagement",
                  params: {
                    planId: this.selectedPlan.Id,
                    edit: true,
                    cms: "new",
                  },
                });
              },
            },
          ],
        },
      ],
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
  },
};
</script>

<style></style>
